import React from 'react';
import { service } from '../Data/data';
import { useParams } from 'react-router-dom';
import PopupForm from '../UI/PopupForm';
import MetaManager from '../Layout/MetaManager'; // ✅ Import MetaManager

const ServiceDetails = () => {
  const { slug } = useParams();
  const selectedService = service.find((item) => item?.slug === slug);

  return (
    <>
      {/* ✅ Dynamic Meta Tag Injection */}
      <MetaManager slug={`service/${slug}`} />

      <div>
        <div className="bg-white">
          <div className="flex justify-around py-10 max-sm:py-0 max-md:py-0 max-sm:pt-5 items-center px-5 max-sm:flex-col-reverse max-md:flex-col-reverse flex-row-reverse max-sm:px-0 max-md:px-0">
            <div className="w-1/2 max-sm:w-full max-md:w-full max-sm:text-center max-md:text-center pl-20 max-sm:pl-0 max-md:pl-0">
              <div className={`h-[150px] flex items-center justify-center`}>
                <div className="max-w-md mx-auto w-full">
                  <h2 className="flex flex-row flex-nowrap items-center my-8">
                    <span
                      className="flex-grow block border-t border-[#07c991a8]"
                      aria-hidden="true"
                    ></span>
                    <span
                      className={`flex-none block px-4 py-2.5 text-4xl font-semibold max-md:text-xl leading-none uppercase text-[#07c991a8]`}
                    >
                      {`${selectedService?.name}`}
                    </span>
                    <span
                      className="flex-grow block border-t border-[#07c991a8]"
                      aria-hidden="true"
                    ></span>
                  </h2>
                </div>
              </div>
              <p className="text-gray-600 mt-4 leading-9">{selectedService?.description}</p>
            </div>
            <div className="w-1/2 max-sm:w-full max-md:w-full">
              <img
                src={selectedService?.image}
                alt={`${selectedService?.name}`}
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>

        <div className="py-16 bg-gray-50 overflow-hidden">
          <div className="container m-auto px-6 space-y-8 text-gray-500 md:px-12">
            <div>
              <span className="text-gray-600 text-lg font-semibold">Key features</span>
            </div>
            <div className="mt-16 grid gap-5 divide-x divide-y rounded-xl overflow-hidden sm:grid-cols-2 lg:divide-y-0 lg:grid-cols-3 xl:grid-cols-3">
              {[1, 2, 3, 4, 5].map((num) => (
                <div
                  key={num}
                  className="relative group bg-white transition hover:z-[1] hover:shadow-2xl rounded-lg"
                >
                  <div className="relative p-8 space-y-8">
                    <div className="space-y-2">
                      <h5 className="text-xl text-gray-800 font-bold transition group-hover:text-[#07c991a8]">
                        {selectedService?.[`keyHeading${num}`]}
                      </h5>
                      <p className="text-md text-gray-600">
                        {selectedService?.[`keyF_${num}`]}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetails;
